import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { CourseService } from '@/services';
import type { UserCourseStatus } from '@/types';

export function useTestResults(courseId?: string) {
  return useQuery({
    queryKey: ['testResults', courseId],
    queryFn: async () => CourseService.getTestResults(courseId ?? ''),
    enabled: !!courseId,
  });
}

export function useSubmitTest() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (courseId: string) => CourseService.submitTest(courseId),
    onSuccess: (courseStatus, courseId) => {
      queryClient.setQueryData<UserCourseStatus>(['userCourseStatus'], courseStatus);
      // Invalidate test results to refresh the list with the new result
      queryClient.invalidateQueries({ queryKey: ['testResults', courseId] });
      // Invalidate exercises to refresh exercise states
      queryClient.invalidateQueries({ queryKey: ['chapters', 'exercise'] });
    },
  });
}

export function useRestartTest() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (courseId: string) => CourseService.restartTest(courseId),
    onSuccess: (status) => {
      queryClient.setQueryData<UserCourseStatus>(['userCourseStatus'], status);
      // Remove all chapter data from cache to prevent showing stale submitted state
      queryClient.removeQueries({ queryKey: ['chapters'] });
    },
  });
}
